import React from 'react';
import ReactToPrint from 'react-to-print';
import { DocketIcon } from '../../assets/icons';
import useLayoutContext from '../../contexts/layout.context';
import {
  getDocketIconColor,
  getDocketSplitColor,
  getDocketTextStyle
} from '../../helpers/permissions.service';

// TODO :: Refactor card button to render different buttons instead of action manipulation
const DocketButton = ({ status, receiptRef }) => {
  const { permissions } = useLayoutContext();
  const { isPackagingRole, isAdminRole } = permissions;

  const textStyle = getDocketTextStyle({ status, isAdminRole });
  const docketIconColor = getDocketIconColor({ status, isAdminRole });
  const docketSplitColor = getDocketSplitColor({ status, isPackagingRole });
  return (
    <div>
      <ReactToPrint
        trigger={() => (
          <button
            className={`flex justify-center w-40 mt-2 py-[8px] rounded-full bg-white d-justify-center d-align-center border-transparent text-sm ${textStyle}`}
            style={{ color: docketSplitColor }}>
            <DocketIcon color={docketIconColor} />

            <h6 className={`mb-0  ${docketIconColor} ml-1`} style={{ color: docketSplitColor }}>
              Print docket
            </h6>
          </button>
        )}
        content={() => receiptRef.current}
      />
    </div>
  );
};

export default DocketButton;
